import {
  type schemaType,
  type paramsType,
  type returnType,
} from '~~/shared/api/strapi/vacaciones-landings/detail/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/vacaciones-landings/detail'

export const serverFetch = (params: paramsType): Promise<returnType> =>
  strapiServerFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  strapiBrowserFetchWrapper<paramsType, schemaType>(endpoint, params)
